export const editableMergeFieldEnum: Record<number, string> = {
    1: 'Case',
    2: 'Employee',
    3: 'Office Address',
    4: 'Events',
}
